import doT from 'dot';
import _ from 'lodash';
import commonExtensions from './Extensions';
import { Mode, BetTypeGroup } from './Foundation';
import {MoreBets} from '../components/CompactView/OddsPageComponent/Templates/MoreBets';
import {TennisMoreBets} from '../components/CompactView/OddsPageComponent/Templates/tennisTemplates/TennisMoreBets';
import {HdpDouble} from '../components/CompactView/OddsPageComponent/Templates/HdpDouble';
import {TennisHdpDouble} from '../components/CompactView/OddsPageComponent/Templates/tennisTemplates/TennisHdpDouble';
import {TennisHdpSingle} from '../components/CompactView/OddsPageComponent/Templates/tennisTemplates/TennisHdpSingle';
import {MoneyLine1x2} from '../components/CompactView/OddsPageComponent/Templates/MoneyLine1x2';
import {TeamTotals} from '../components/CompactView/OddsPageComponent/Templates/TeamTotals';
import {HdpSingle} from '../components/CompactView/OddsPageComponent/Templates/HdpSingle';
import {Outright} from '../components/CompactView/OddsPageComponent/Templates/Outright';
import {TennisMoneyLine1x2} from '../components/CompactView/OddsPageComponent/Templates/tennisTemplates/TennisMoneyLine1x2';
import Constants from './Constants';

export default class doTUtils {

    static init() {        
        doT.templateSettings.varname = "data";
    }

    static getTemplate(options) {
        const isNewTennis = window.env.isUseNewTennisLayout && options.sportId === Constants.TENNIS_ID;
        const templates = {
            HDP_OU: isNewTennis ? [TennisHdpSingle, TennisHdpDouble] : [HdpSingle, HdpDouble],
            ML_1X2: isNewTennis ? [TennisMoneyLine1x2] : [MoneyLine1x2],
            TEAM_TOTAL: [TeamTotals],
            OUTRIGHT: Outright
        }
        if (options.mode === Mode.TEASER || options.mode === Mode.TEASER_MARKET) {
          return templates.TEASERS[options.oddsMode];
        } else if (options.mode === Mode.OUTRIGHT || options.mode === Mode.OUTRIGHT_MARKET){
            return templates.OUTRIGHT;
        }
        let tpl = options.betTypeGroup == BetTypeGroup.MIX_PARLAY ? templates['HDP_OU'] : templates[(_.invert(BetTypeGroup))[options.betTypeGroup]];
        // let oddsLayout = tpl.length > options.oddsMode ? options.oddsMode : 0;
        // return tpl[oddsLayout];
        let oddsLayout = tpl && tpl.length > options.oddsMode ? options.oddsMode : 0;
        return tpl ? tpl[oddsLayout] : templates.HDP_OU[0];
    }

    static bindMoreBetsData(data, options) {
        this.init();
        const isShowNewTennis = this.useNewTennisMoreBetTemplate(options);
        const content = doT.template(isShowNewTennis ? TennisMoreBets : MoreBets)(data, options);
        return content.trim();
    }

    static useNewTennisMoreBetTemplate(options) {
        const betTypeOldTemplate = [BetTypeGroup.TEAM_TOTAL, BetTypeGroup.OUTRIGHT];
        return window.env.isUseNewTennisLayout && options.sportId === Constants.TENNIS_ID 
            && !betTypeOldTemplate.includes(parseInt(options.betTypeGroup)) && options.mode !== Mode.TV;
    } 

    static bindData(data, options) {
        this.init();
        data.options = options;
        const content = doT.template(this.getTemplate(options))(data, options);
        return content.trim();
    }
}


// WEBPACK FOOTER //
// ./src/app/common/doTUtils.js